import gButton from "@/components/g-button/g-button";
import gCard from "@/components/g-card/g-card";
import gDateInput from "@/components/g-date-input/g-date-input";
import gForm from "@/components/g-form/g-form";
import axios from 'axios';
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators"
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";

const name = 'InfoBasicasRA'

export class PhotoService {

  async getImage(produtoSelecionadoId, images) {
    images = await axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoArquivo/${produtoSelecionadoId}`,
    }).then((response) => images = response.data.data)
    .catch(() => {
    });
    return images
  }
}

export default defineComponent({
  name,

  components: {
    'g-date-input': gDateInput,
    'g-form': gForm,
    'g-card': gCard,
    'g-button': gButton,
  },

  props: {},

  setup() {
    return {
      v$: useVuelidate()
    }
  },

  mounted() {
    // this.populandoDropdownProduto()
    this.ComponenteIdByOrcamentoId()
    this.GetProdutoByOrcamentoId()
    this.populaInfosBasicas()
    this.ImagemEmpresa()
  },

  updated() { },

  data() {
    return {
      popupCancelaOrc: false,
      ProdutoSelecionadoId: '',
      caminhoImagem: '',
      styleImg: '',
      displayModalConfirmacao: false,
      descricaoOutrosMateriais: '',
      opcoesAmostraReferencia: [],
      quantidade: null,
      options: [],
      produtos: [],
      componente: [],
      categories: [{ name: 'Acompanha amostra', key: 'A' }, { name: 'Marketing', key: 'M' }, { name: 'Production', key: 'P' }, { name: 'Research', key: 'R' }],
      selectedCategories: [],
      produtoSelecionadoId: null,
      quantidadeProduto: 0,
      dataCarregamento: null,
      outrosmateriaisop: false,
      ehAdicao: true,
      desativarCampoIncial: false,
      copiaOrcamentoQuantidade:false,
      numberRow: 0,
      infoEntregaProduto: [],
      ProdutoId: null,
      ComponenteId: null,
      OrcamentoId: null,
      ComissaoId: null,
      EmpresaId: null,
      nomeProduto: '',
      nomeProdutoRA: '',
      AcompanhaAmostra: false,
      observacoes: '',
      Quantidade2: null,
      EspecificacaoTecnica: false,
      MateriaisCliente: '',
      img: '',
      images: {
        arquivo: '',
        arquivobase64: '',
        files: '',
        id: '',
        produto: '',
      },
      responsiveOptions: [
        {
          breakpoint: '10024px',
          numVisible: 5
        },
        {
          breakpoint: '7px',
          numVisible: 3
        },
        {
          breakpoint: '5600px',
          numVisible: 1
        }
      ],
      produtoPreenchidoId: '',
      infosBasicas: {},
      timer: null,
      imagemEmpresa: ''
    }
  },

  validations() {
    let quaisMateriaisValidation
    // let observacoesValidation = {}
    let quantidadeValidation
    let dataCarregamentoValidation = {}

    // const dataCarregamentoRequired = () => {
    //   /* eslint-disable */
    //   if(this.dataCarregamento){
    //     return true
    //   }

    //   return required

    // }

    // const observacoesRequered = () => {
    //   if(this.observacoes){
    //     return true
    //   }

    //   return required
    // }

    quantidadeValidation = {}
    dataCarregamentoValidation = {}

    //observacoesValidation = this.testeObservacoes

    quantidadeValidation = {
      required: helpers.withMessage('O campo de Quantidade necessita de um valor', required)
    }

    dataCarregamentoValidation = this.testeDataCarregamento


    if (this.options.includes('0') || this.options.includes('2')) {  //2 === outrosMaterias
      quaisMateriaisValidation = {
        required: helpers.withMessage('O campo Quais Materiais é obrigatório', required)
      }
    } else {
      quaisMateriaisValidation = {}
    }

    return {
      // nomeProduto: {
      //   required: helpers.withMessage('O campo de Nome Produto é obrigatório', required)
      // },

      quantidade: quantidadeValidation,
      dataCarregamento: dataCarregamentoValidation,
      quaisMateriais: quaisMateriaisValidation,
      // observacoes: observacoesValidation,

    }
  },

  galerriaService: null,
  created() {
    this.galerriaService = new PhotoService();
  },

  methods: {
    verificarDatasRetroativas(infoEntregaProduto) {
      const dataAtual = new Date(); // Data atual
      dataAtual.setHours(0, 0, 0, 0);

      const verificaSeTemRetroativa = infoEntregaProduto.some(item => {
          const { dataCarregamento } = item;

          if (!dataCarregamento) {
            return false;
        }
  
          // Divide a string em partes (dia, mês, ano) e cria um novo objeto Date
          const [dia, mes, ano] = dataCarregamento.split('/');
          const dataCarregada = new Date(ano, mes - 1, dia); // Mês é zero-indexado
          dataCarregada.setHours(0, 0, 0, 0);

          return dataCarregada < dataAtual;
      });
      return verificaSeTemRetroativa;
    },
    
    TemQuantidadesIguais(arr) {
      let occurrences = {};

      return arr.some(function(item) {
        if (occurrences[item.quantidade]) {
          return true; // Quantidade repetida encontrada
        } else {
          occurrences[item.quantidade] = true;
          return false;
        }
      });
    },
    estaOrdenadoCrescente(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        // Convertendo as quantidades para números
        const quantidadeAtual = parseFloat(arr[i].quantidade);
        const proximaQuantidade = parseFloat(arr[i + 1].quantidade);
    
        if (quantidadeAtual > proximaQuantidade) {
          return false;
        }
      }
      return true;
    },
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-alteracao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    erro(e){
      if(e == undefined){
        this.caminhoImagem = require('@/assets/imgs/Ilustracao_Nenhuma_Img.svg')
        this.styleImg = 'width: 100px'
      }
    },
    changeCheckboxAmostra(){
      if(this.contemAmostra){
        this.ligarCampoEPopup()
      }
    },

    changeCheckboxOutros(){
      if(this.contemOutros){
        this.ligarCampoEPopup()
      }
    },

    changeCheckboxEspecificacoes(){
      if(!this.contemAmostra){
        this.opcoesAmostraReferencia.unshift('0')
        this.ligarCampoEPopup()
      }
    },

    ligarCampoEPopup(){
      this.outrosmateriaisop = true
      if(!(this.contemAmostra && this.contemOutros)){
        this.displayModalConfirmacao = true
      }
    },

    populaInfosBasicas(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `resgata/informacoes/basicas/${this.$route.params.id}`,
      })
        .then((Response) => {
          let infosBasicas = Response.data.data
          if(infosBasicas != null){
            this.copiaOrcamentoQuantidade = infosBasicas.copiaOrcamentoQuantidade;
            this.desativarCampoIncial = infosBasicas.reorcamento;
            this.produtoSelecionadoId = infosBasicas.produtoId;
            this.nomeProduto = infosBasicas.nomeProduto;
            this.nomeProdutoRA = infosBasicas.nomeProdutoRA;
            this.observacoes = infosBasicas.observacao;
            this.quantidade = infosBasicas.dataQuantidadeArray[0].quantidade;
            this.dataCarregamento = infosBasicas.dataQuantidadeArray[0].dataCarregamentoFormatada;
            this.produtos = infosBasicas.produtoSelecionadoLista;

            if(infosBasicas.amostra)
              this.opcoesAmostraReferencia.push('0')
            if(infosBasicas.amostraEspecificacaoTecnica)
              this.opcoesAmostraReferencia.push('1')
            if(infosBasicas.outros)
              this.opcoesAmostraReferencia.push('2')
            this.descricaoOutrosMateriais = infosBasicas.descricaoOutrosMateriais;
            this.chamarImagem()
            if(infosBasicas.dataQuantidadeArray.length > 1) {
              for (let i = 1; i < infosBasicas.dataQuantidadeArray.length; i++) {
                var element = {
                  quantidade: infosBasicas.dataQuantidadeArray[i].quantidade,
                  dataCarregamento: infosBasicas.dataQuantidadeArray[i].dataCarregamentoFormatada
                };
                this.infoEntregaProduto.push(element)
              }
            }
          }
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    buscarProdutos(pesquisa){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.produtos = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true, true, pesquisa).ProdutoArray;
      }, 1000);
    },
    getProdutoIdByOrcamentoId() {

      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoByOrcamentoId/${this.$route.params.id}`,
      })
        .then((Response) => {
          this.ProdutoId = Response.data.data
        })
        .catch(() => {
        });
    },

    GetProdutoByOrcamentoId() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoByOrcamentoId/${this.$route.params.id}`,
      }).then(Response => {
        this.produtoSelecionadoId = Response.data.data.id;
      })
        .catch(() => {
        });
    },

    chamarImagem(){
      if(this.produtoSelecionadoId){
        const { labelProduto } = this.produtos.filter(x => x.produtoId == this.produtoSelecionadoId)[0];
        const codigoProduto = labelProduto.split('-')[0];
        const nomeEmpresa = () => {
          let nome = labelProduto.split('|')[1];
          if(nome.includes('SUPREMA')) return 'SUPREMA';
          if(nome.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.caminhoImagem =  `http://${urlBase}/repositorio/${nomeEmpresa()}/${codigoProduto.trim()}.jpg`;
        setTimeout(() => {
          this.styleImg = 'width: 400px'
        });
      }
      else{
        this.caminhoImagem = ''
      }
    },

    habilitarcampo2() {
      if (this.opcoesAmostraReferencia.includes('0') || this.opcoesAmostraReferencia.includes('2') && !this.displayModalConfirmacao) {
        this.outrosmateriaisop = true
        this.displayModalConfirmacao = true
      } else {
        this.outrosmateriaisop = false
        this.displayModalConfirmacao = false
      }
    },

    ComponenteIdByOrcamentoId() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Produto/GetComponenteIdByOrcamentoID/${this.$route.params.id}`,
      }).then()
        .catch(() => {
        });
    },

    validateQuant() {
      if (this.v$.$invalid === true) {
        this.v$.$silentErrors.forEach(error => {
          this.$toast.add({ severity: 'error', summary: 'ERRO', detail: error.$message, life: 5000 })
        })

      } else {
        this.popup = true
        this.insertOrcamentoQuantidadeRA()
      }
    },

    insertOrcamentoQuantidadeRA() {
      this.$refs.botaoContinuar.isBusy()

      let infoEntregaProduto = JSON.parse(JSON.stringify(this.infoEntregaProduto))
      if(this.quantidade != ''){
        infoEntregaProduto.unshift({
          quantidade: this.quantidade,
          dataCarregamento: this.dataCarregamento
        })
      }

      if(this.verificarDatasRetroativas(infoEntregaProduto) === true && !this.desativarCampoIncial){
        this.$toast.add({ severity: 'error', summary: 'Erro, as datas não podem ser retroativas', life: 3200 });
        this.escritobotao = true
        return
      }

      infoEntregaProduto.forEach((e) => {
        e.quantidade = `${e.quantidade}`
      })

      const nomeProdutoComEmpresa = this.produtos.filter(x => x.produtoId == this.produtoSelecionadoId)[0].labelProduto
      const nomeProdutoSemEmpresa = nomeProdutoComEmpresa.split('|')[0]
      const nomeProdutoSemCodigo = nomeProdutoSemEmpresa.split('-')[1].trim()
      const codigoProduto = nomeProdutoSemEmpresa.split('-')[0].trim()

      let orcamentoquantidadeArray = {
        NomeProduto: nomeProdutoSemCodigo,
        codigoProduto: codigoProduto,
        OrcamentoId: this.$route.params.id, // gerar dentro dele um produto id
        ComponenteId: this.ComponenteId, // preencher para criar orçamento componente
        ComissaoId: this.ComissaoId,
        EmpresaId: this.EmpresaId,
        Observacao: this.observacoes,
        ProdutoId: this.produtoSelecionadoId,
        AcompanhaAmostra: this.AcompanhaAmostra,
        EspecificacaoTecnica: this.EspecificacaoTecnica,
        Quantidade: this.Quantidade,
        Quantidade2: this.Quantidade2,
        DataCarregamento: new Date(this.DataCarregamento),
        DataCarregamento2: null,
        MateriaisCliente: this.MateriaisCliente,
        DataQuantidadeArray: infoEntregaProduto,

        Amostra: this.contemAmostra,
        AmostraEspecificacaoTecnica: this.contemEspecificacoes,
        Outros: this.contemOutros,
        DescricaoOutrosMateriais: this.descricaoOutrosMateriais,
      }


      let EstaOrdenado= this.estaOrdenadoCrescente(orcamentoquantidadeArray.DataQuantidadeArray)

      if(EstaOrdenado == false)
      {
        this.$toast.add({severity:'error', summary: 'As quantidades devem estar ordenadas.', detail:"As quantidades devem estar ordenadas da menor para a maior.", life: 5000})
        this.escritobotao = true
        this.$refs.botaoContinuar.isBusy()
        this.$isLoading(false) 

        return
      } 
      let quantidadesIguais= this.TemQuantidadesIguais(orcamentoquantidadeArray.DataQuantidadeArray)

      if(quantidadesIguais == true)
        {
          this.$toast.add({severity:'error', summary: 'Erro', detail:"Não são permitidas quantidades iguais.", life: 5000})
          this.escritobotao = true
          this.$refs.botaoContinuar.isBusy()
          this.$isLoading(false) 
          
          return
        } 
      else{
        this.axios({
          method: 'post',
          url: process.env.VUE_APP_WEB_API + 'enviar/informacoes/basicas/RA',
          data: orcamentoquantidadeArray

        })
          .then((response) => {
            if (response.data.code === 200) {
              if( this.contemEspecificacoes)
                this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/caracteristicas-produto-ra`)
              else
                this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/componentes-produto-ra`)
            }
            this.$isLoading(false) 
          }).finally(() => this.$refs.botaoContinuar.isBusy)

      }
    },

    populandoDropdownProduto() {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
      this.produtos = ProdutoController.getProdutoDropDown(this.$route.params.id, true, true).ProdutoArray
      }, 1000);
    },
    fecharDialog() {
      this.displayModalConfirmacao = false
    },
    habilitarcampof() {
      if (this.opcoesAmostraReferencia.includes('0') || this.opcoesAmostraReferencia.includes('2') && !this.displayModalConfirmacao) {
        this.outrosmateriaisop = true
      } else {
        this.outrosmateriaisop = false
      }
    },

    camponumero($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57)|| ($event.type == 'change')) { // 46 is dot
        $event.preventDefault();
      }
    },
    step4() {

      if (this.v$.$invalid === true) {
        this.v$.$silentErrors.forEach(error => {
          this.$toast.add({ severity: 'error', summary: 'ERRO', detail: error.$message, life: 5000 })
        })

      } else {
        this.$isLoading(true)
        this.insertOrcamentoQuantidadeRA()
      }

    },
    voltarstep2 () {
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/lote-frete-ra`)
    },

    addRow() {
      if(!this.desativarCampoIncial){
        if((this.infoEntregaProduto.length == 2) || !(this.quantidade) && (!this.dataCarregamento)){
        return
      }
      this.infoEntregaProduto.push({
        quantidade: '',
        dataCarregamento: null
      });

      }
    },
    deleteRow(index) {
      if(!this.desativarCampoIncial){
        this.infoEntregaProduto.splice(index, 1);

      }
    },
  },

  computed: {
    contemOutros(){
      return this.opcoesAmostraReferencia.includes('2')
    },

    contemAmostra(){
      return this.opcoesAmostraReferencia.includes('0')
    },

    contemEspecificacoes(){
      return this.opcoesAmostraReferencia.includes('1')
    },

    dataObrigatoria(){
      let observacaoPreenchida = Tools.validaVariavelPreenchida(this.observacoes);
      return observacaoPreenchida;
    },

    observacaoObrigatoria(){
      let dataNaoPreenchida = Tools.validaVariavelPreenchida(this.dataCarregamento);
      this.infoEntregaProduto.forEach((e)=>{
        if(Tools.validaVariavelPreenchida(e.dataCarregamento)){
          dataNaoPreenchida = true;
        }
      });
      return dataNaoPreenchida;
    },

    testeDataCarregamento(){
      if(this.observacoes){
        return {}
      }
      return {
        required: helpers.withMessage('O campo de Data de Carregamento necessita de um valor ou campo observações', required)
      }
    }
  },

});